import { Component, Input, SimpleChanges } from '@angular/core';
import { Chart } from 'chart.js/auto';

@Component({
  selector: 'app-parts-line-chart',
  templateUrl: './parts-line-chart.component.html',
  styleUrls: ['./parts-line-chart.component.scss']
})
export class PartsLineChartComponent {
  chart: any;
  // selectedView = 'monthly';
  // selectedYear = new Date().getFullYear();
  // availableYears = [2023, 2024, 2025, 2026];

  @Input() view: string = 'Monthly'; // Receive view type
  @Input() selectedYear: number = new Date().getFullYear(); // Receive selected year

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['view'] || changes['selectedYear']) {
      this.updateChart();
    }
  }

  ngAfterViewInit() {
    this.initChart();
  }

  // /**
  //  * Create Sales chart based on data
  //  * @param labels 
  //  * @param data 
  //  */
  // createSalesChart(labels: string[], data: number[]): void {
  //   const ctx = document.getElementById('partSalesChart') as HTMLCanvasElement;
  //   // Destroy the previous chart before creating a new one
  //   if (this.chart) {
  //     this.chart.destroy(); 
  //   }

  //   // Check if only one data point exists and duplicate it for smooth line
  //   if (labels.length === 1) {
  //     labels.push(labels[0]); // Add duplicate label
  //     data.push(data[0]); // Add duplicate data point
  //   }

  //   this.chart = new Chart(ctx, {
  //     type: 'line',
  //     data: {
  //       labels: labels,
  //       datasets: [
  //         {
  //           data: data.,
  //           borderColor: '#4f46e5',
  //           backgroundColor: 'rgba(79, 70, 229, 0.2)',
  //           fill: true,
  //           tension: 0.4,
  //         },
  //       ],
  //     },
  //     options: {
  //       responsive: true,
  //       plugins: {
  //         legend: {
  //           display: false,
  //         },
  //       },
  //       scales: {
  //         x: {
  //           display: true,
  //         },
  //         y: {
  //           display: true,
  //         },
  //       },
  //     },
  //   });
  // }

  initChart() {
    const ctx = document.getElementById('partSalesChart') as HTMLCanvasElement;
    this.chart = new Chart(ctx, {
      type: 'line',
      data: {
        labels: [], // Dynamic labels
        datasets: [
          {
            label: 'Part Buy',
            data: [], // Dynamic data for Part Buy
            borderColor: '#ffc107',
            fill: false,
            tension: 0.3,
          },
          {
            label: 'Part Sell',
            data: [], // Dynamic data for Part Sell
            borderColor: '#4f46e5',
            fill: false,
            tension: 0.3,
          },
        ],
      },
      options: {
        responsive: true,
        plugins: {
          legend: {
            position: 'top',
          },
        },
      },
    });
    this.updateChart();
  }

  updateChart() {
    const data = this.getChartData();
    this.chart.data.labels = data.labels;
    this.chart.data.datasets[0].data = data.partBuyData;
    this.chart.data.datasets[1].data = data.partSellData;

    // Handle single data point by adjusting point radius
    this.handleSingleDataPoint(data.partBuyData, 0);
    this.handleSingleDataPoint(data.partSellData, 1);

    this.chart.update();
  }

  handleSingleDataPoint(data: number[], datasetIndex: number) {
    if (data.length === 1) {
      this.chart.data.datasets[datasetIndex].pointRadius = 6;
      this.chart.data.datasets[datasetIndex].showLine = false;
    } else {
      this.chart.data.datasets[datasetIndex].pointRadius = 5;
      this.chart.data.datasets[datasetIndex].showLine = true;
    }
  }

  getChartData() {
    if (this.view === 'Monthly') {
      return this.getMonthlyData(this.selectedYear);
    } else if (this.view === 'Quaterly') {
      return this.getQuarterlyData(this.selectedYear);
    } else {
      return this.getYearlyData();
    }
  }

  getMonthlyData(year: number) {
    if(year == 2025){
      return {
        labels: [
          'Jan', 'Feb', 'Mar'
        ],
        partBuyData: [50, 70, 60],
        partSellData: [40, 65, 55],
      };
    } else if(year == 2024){
      return {
        labels: [
          'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
          'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
        ],
        partBuyData: [150, 70, 160, 80, 90, 100, 110, 95, 85, 120, 130, 140],
        partSellData: [40, 165, 55, 175, 85, 195, 105, 185, 75, 115, 125, 135],
      };
    } else{
      return {
        labels: [
          'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
          'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
        ],
        partBuyData: [120, 70, 100, 80, 90, 100, 150, 95, 85, 120, 130, 140],
        partSellData: [40, 165, 55, 175, 85, 95, 105, 105, 75, 115, 125, 135],
      };
    }
  }

  getQuarterlyData(year: number) {
    if(year == 2025){
      return {
        labels: ['Q1'],
        partBuyData: [180],
        partSellData: [170],
      };
    } else if(year == 2024){
      return {
        labels: ['Q1', 'Q2', 'Q3', 'Q4'],
        partBuyData: [220, 210, 240, 260],
        partSellData: [170, 200, 230, 250],
      };
    } else{
      return {
        labels: ['Q1', 'Q2', 'Q3', 'Q4'],
        partBuyData: [180, 210, 240, 260],
        partSellData: [170, 200, 230, 250],
      };
    }
    
  }

  getYearlyData() {
    return {
      labels: ['2021', '2022', '2023', '2024', '2025'],
      partBuyData: [1200, 1300, 1400, 1500, 1600],
      partSellData: [1100, 1250, 1350, 1450, 1550],
    };
  }
}
